import React from 'react';
import PropTypes from 'prop-types';

import { Translator } from 'ggApp/modules/translator';
import { search as searchUrl } from 'ggApp/utils/urlBuilder/frontshop';
import { isFunction } from 'ggApp/utils/function';
import If from 'ggApp/shared/components/Conditional';

import Products from './Products';
import TrendingContent from './TrendingContent';

import { Wrap, Loader, NoResultsWrap, Line, NoResultsText, Button } from './styles';

export default class ExpandedContent extends React.PureComponent {
    viewSearchResults = () => {
        const { mainTransition, query, onClickCta } = this.props;
        if (window.ga) {
            window.ga('send', 'pageview', `/search?filter=search%3D${query}`);
        }

        if (isFunction(onClickCta)) {
            onClickCta(query);
        }

        if (query) {
            mainTransition(searchUrl(query), true);
        }
    };

    viewTrendingProducts = () => {
        const { mainTransition, onClickCta, query } = this.props;

        if (isFunction(onClickCta)) {
            onClickCta(query);
        }

        mainTransition('/trending', true);
    };

    render() {
        const {
            closeOverlay,
            searchProducts,
            trendingProducts,
            searchQuery,
            totalItems,
            className,
            contentRef,
            handleTouchStart,
            isLoading,
            query,
        } = this.props;

        const hasActiveQuery = searchQuery.length > 0;
        const hasResults = searchProducts.length > 0;
        const showTrendingContent =
            Boolean(trendingProducts.length) && (!hasActiveQuery || !hasResults);
        const buttonTk = showTrendingContent
            ? 'SEARCHBAR_BUTTON_VIEW_PRODUCTS'
            : 'SEARCHBAR_BUTTON_VIEW_RESULTS';
        const viewAllProducts = showTrendingContent
            ? this.viewTrendingProducts
            : this.viewSearchResults;
        return (
            <Wrap ref={contentRef} className={className} onTouchStart={handleTouchStart}>
                {isLoading && <Loader />}
                {!isLoading && (
                    <>
                        {hasActiveQuery && !hasResults && (
                            <NoResultsWrap>
                                <Line
                                    title={
                                        <Translator
                                            tk="SEARCHBAR_RESULTS_QTY"
                                            withValues={{ totalItems: 0 }}
                                        />
                                    }
                                />
                                <NoResultsText>
                                    <Translator tk="SEARCHBAR_NO_RESULTS_TEXT" />
                                </NoResultsText>
                            </NoResultsWrap>
                        )}
                        {hasResults && (
                            <Products
                                totalItems={totalItems}
                                handleClick={closeOverlay}
                                products={searchProducts}
                                withSearchedProducts
                                query={query}
                            />
                        )}
                        {showTrendingContent && (
                            <TrendingContent
                                handleClick={closeOverlay}
                                trendingProducts={trendingProducts}
                            />
                        )}
                        <If condition={(hasResults && totalItems > 40) || showTrendingContent}>
                            <Button onClick={viewAllProducts}>
                                <Translator tk={buttonTk} />
                            </Button>
                        </If>
                    </>
                )}
            </Wrap>
        );
    }
}

ExpandedContent.propTypes = {
    className: PropTypes.string,
    query: PropTypes.string,
    mainTransition: PropTypes.func,
    contentRef: PropTypes.func,
    handleTouchStart: PropTypes.func,
    closeOverlay: PropTypes.func,
    searchQuery: PropTypes.string,
    totalItems: PropTypes.number,
    searchProducts: PropTypes.arrayOf(
        PropTypes.shape({
            length: PropTypes.number,
        }),
    ),
    onClickCta: PropTypes.func,
};

ExpandedContent.defaultProps = {
    query: '',
    mainTransition: () => {},
    className: '',
    searchQuery: '',
    totalItems: 0,
    closeOverlay: () => {},
    searchProducts: [{}],
    contentRef: () => {},
    handleTouchStart: () => {},
    onClickCta: () => {},
};
